import EventBus from '../services/service.eventBus';
import { state as answerState, onChange as onAnswerChange } from '../store/store.answers';
import { state as validationState } from '../store/store.validation';
import { getKeysModificationsProperties } from '../utils/utils.answers';
import { QUESTION_TOGGLE_MODIFICATIONS, QUESTION_TWO_KEYS } from '../utils/utils.question';

export const onKeysModificationsFormInit = () => {
  // Run validation on init using any answers loaded from session storage
  validateKeysModificationsForm(true);

  // Set event listeners to validate on subsequent changes
  onAnswerChange('history', validateKeysModificationsForm);
  onAnswerChange('conditions', validateKeysModificationsForm);
};

const validateKeysModificationsForm = (strobe: boolean = false) => {
  const answers = getKeysModificationsProperties(answerState);

  const errors = new Set<string>();
  if (answers[QUESTION_TWO_KEYS]?.value === '') {
    errors.add(QUESTION_TWO_KEYS);
  }

  if (answers[QUESTION_TOGGLE_MODIFICATIONS]?.value === '') {
    errors.add(QUESTION_TOGGLE_MODIFICATIONS);
  }

  const newIsValid = !errors.size;
  const oldIsValid = validationState.result.keysModifications;

  validationState.form = {
    ...validationState.form,
    keysModifications: errors,
  };

  validationState.result = {
    ...validationState.result,
    keysModifications: newIsValid,
  };

  if (strobe || newIsValid !== oldIsValid) {
    EventBus.publish('FormValidated', { form: 'keys-modifications-form', isValid: newIsValid });
  }
};
